import { render, staticRenderFns } from "./ChinaPay.vue?vue&type=template&id=365b08b3&scoped=true"
import script from "./ChinaPay.vue?vue&type=script&lang=js"
export * from "./ChinaPay.vue?vue&type=script&lang=js"
import style0 from "./ChinaPay.vue?vue&type=style&index=0&id=365b08b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365b08b3",
  null
  
)

export default component.exports